import Vue from 'vue'
export default {
	//版本号
	Version: '1.0.0',
	//根域名，必填
	DoMain: 'c.com',
	//接口地址，分生产线和开发线，必填
	ApiUrl: (process.env.NODE_ENV == 'production') ? 'http://api.buyun.co' : 'http://api.c.com',
	//www站点地址，分生产线和开发，必填
	WwwUrl: (process.env.NODE_ENV == 'production') ? 'http://buyun.co/' : 'http://www.c.com',
	//接口密钥，必填
	PrivateKey: '9IUYGv58',
	//url根目录名称，可以为空
	RootDirName: '',
	//客户端语言种类，必填
	ClientLangData: [
		{ langName: 'CN', langTitle: '简体中文' },
		{ langName: 'EN', langTitle: 'English' },
	],
	//客户端默认语种,CN中文，EN英文，必填
	ClientDefaultLang: 'CN',
};


// WEBPACK FOOTER //
// ./src/assets/js/rwConfig.js